import { PlayerPosition, PlayerStatus } from "src/app/enums/Index";
import { Model } from "./Model";
import { Sponsor, Team } from "./Index";

export interface Player extends Model {
	awaySponsorId: number;
	awaySponsor: Sponsor;
	celebrationImage: string;
	manOfTheMatchImage: string;
	mugshotUrl: string;
	playerName: string;
	playerNumber: number;
	playerStatus: PlayerStatus;
	playerPosition: PlayerPosition;
	sponsorId: number;
	sponsor: Sponsor;
	sponsorText: string;
	teamId: number;
	team: Team;
	thirdSponsorId: number;
	thirdSponsor: Sponsor;
}

export class Player implements Player {

	constructor(data?: Partial<Player>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}